import * as React from "react";
import Helmet from "react-helmet";

const termly = require("../../utils/termly.js").default;

const PrivacyPage = () => {
  return (
    <main>
      <Helmet>
        <script type="text/javascript">
          {`(function (d, s, id) {
            var js,
              tjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://app.termly.io/embed-policy.min.js";
            tjs.parentNode.insertBefore(js, tjs);
          })(document, "script", "termly-jssdk")`}
        </script>
      </Helmet>

      <title>EPHAS Privacy Policy</title>
      <div dangerouslySetInnerHTML={{ __html: termly }} />
    </main>
  );
};

export default PrivacyPage;
